import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCliente } from "../context/ClienteContext";
import "../styles/global.css";

const EditarTurma = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { parametros } = useCliente();

  const [codigo, setCodigo] = useState("");
  const [nome, setNome] = useState("");
  const [dataInicio, setDataInicio] = useState("");
  const [dataTermino, setDataTermino] = useState("");
  const [cursoSelecionado, setCursoSelecionado] = useState(null);

  const [cursos, setCursos] = useState([]);
  const [filtroCodigo, setFiltroCodigo] = useState("");
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroNivel, setFiltroNivel] = useState("");
  const [filtroModalidade, setFiltroModalidade] = useState("");
  const [filtroCoordenador, setFiltroCoordenador] = useState("");
  const [erros, setErros] = useState({});

  const formatarDataParaInput = (dataString) => {
    if (!dataString) return "";
    if (dataString.includes("T")) {
      return dataString.substring(0, 10); // já no formato ISO
    }
    const partes = dataString.split("/");
    if (partes.length === 3) {
      return `${partes[2]}-${partes[1].padStart(2, '0')}-${partes[0].padStart(2, '0')}`;
    }
    return dataString;
  };
  

  useEffect(() => {
    const carregarDados = async () => {
      try {
        const turmaResponse = await axios.get(`/api/turmas/${id}`);
        const clienteId = localStorage.getItem("cliente_id");
        const cursosResponse = await axios.get(`/api/cursos?cliente_id=${clienteId}`);

        if (turmaResponse.data) {
          const turma = turmaResponse.data;
          setCodigo(turma.codigo);
          setNome(turma.nome);
          setDataInicio(formatarDataParaInput(turma.data_inicio));
          setDataTermino(formatarDataParaInput(turma.data_termino));
          setCursoSelecionado(turma.curso_id);
        }
        setCursos(cursosResponse.data);
      } catch (error) {
        console.error("Erro ao carregar dados da turma:", error);
        alert("Erro ao carregar dados da turma. Tente novamente.");
      }
    };

    carregarDados();
  }, [id]);

  const validarCampos = () => {
    const novosErros = {};
  
    if (!codigo.trim()) novosErros.codigo = "Código da turma é obrigatório.";
    if (!nome.trim()) novosErros.nome = "Nome da turma é obrigatório.";
    if (!dataInicio) novosErros.dataInicio = "Data de início é obrigatória.";
    if (!dataTermino) novosErros.dataTermino = "Data de término é obrigatória.";
    if (dataInicio && dataTermino && new Date(dataTermino) < new Date(dataInicio)) {
      novosErros.dataTermino = "Data de término não pode ser anterior à data de início.";
    }
    if (!cursoSelecionado) novosErros.curso = "Selecione um curso para a turma.";
  
    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!validarCampos()) {
      return;
    }
  
    const data = {
      codigo,
      nome,
      curso_id: cursoSelecionado,
      data_inicio: dataInicio,
      data_termino: dataTermino,
      usuario_id: parseInt(localStorage.getItem("user_id"), 10)
    };
  
    try {
      await axios.put(`/api/turmas/${id}`, data);
      alert("Turma atualizada com sucesso!");
      navigate(`/detalhes-turma/${id}`);
    } catch (error) {
      console.error("Erro ao atualizar turma:", error);
      alert("Erro ao atualizar a turma. Tente novamente.");
    }
  };
  

  const cursosFiltrados = cursos.filter(curso => {
    return (
      (!filtroCodigo || (curso.codigo && curso.codigo.toLowerCase().includes(filtroCodigo.toLowerCase()))) &&
      (!filtroNome || (curso.nome && curso.nome.toLowerCase().includes(filtroNome.toLowerCase()))) &&
      (!filtroNivel || (curso.nivel && curso.nivel === filtroNivel)) &&
      (!filtroModalidade || (curso.modalidade && curso.modalidade === filtroModalidade)) &&
      (!filtroCoordenador || (curso.coordenador_nome && curso.coordenador_nome.toLowerCase().includes(filtroCoordenador.toLowerCase())))
    );
  });
  

  const niveis = [...new Set(cursos.map(c => c.nivel))];
  const modalidades = [...new Set(cursos.map(c => c.modalidade))];
  const coordenadores = [...new Set(cursos.map(c => c.coordenador_nome))];

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Editar Turma</h2>

      <form onSubmit={handleSubmit}>
        {/* Código e Nome */}
        <div className="form-row">
          <div className="form-group" style={{ width: "220px" }}>
            <label>Código da Turma*</label>
            <input
              type="text"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
              className="input-form"
            />
            {erros.codigo && <div className="erro-validacao">{erros.codigo}</div>}

          </div>
          <div className="form-group" style={{ flex: 1, marginLeft: "10px" }}>
            <label>Nome da Turma*</label>
            <input
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              className="input-form"
            />
            {erros.nome && <div className="erro-validacao">{erros.nome}</div>}
          </div>
        </div>

        {/* Datas */}
        <div className="form-row">
          <div className="form-group" style={{ width: "220px" }}>
            <label>Data de Início*</label>
            <input
              type="date"
              value={dataInicio}
              min="1900-01-01"
              max="2100-12-31"
              onChange={(e) => setDataInicio(e.target.value)}
              className="input-form"
            />
            {erros.dataInicio && <div className="erro-validacao">{erros.dataInicio}</div>}
          </div>
          <div className="form-group" style={{ width: "220px", marginLeft: "10px" }}>
            <label>Data de Término*</label>
            <input
              type="date"
              value={dataTermino}
              min="1900-01-01"
              max="2100-12-31"
              onChange={(e) => setDataTermino(e.target.value)}
              className="input-form"
            />
            {erros.dataTermino && <div className="erro-validacao">{erros.dataTermino}</div>}
          </div>
        </div>

        {/* Linha divisória */}
        <hr style={{ borderColor: parametros?.cor_cabecalho || "#156082" }} />

        {/* Filtros */}
        <div className="form-row filtros" style={{ gap: "10px", marginTop: "10px", alignItems: "center", flexWrap: "nowrap" }}>
          <input
            type="text"
            placeholder="Filtrar Código"
            value={filtroCodigo}
            onChange={(e) => setFiltroCodigo(e.target.value)}
            className="input-form"
            style={{ width: "140px" }}
          />
          <input
            type="text"
            placeholder="Filtrar Nome"
            value={filtroNome}
            onChange={(e) => setFiltroNome(e.target.value)}
            className="input-form"
            style={{ width: "180px" }}
          />
          <select
            value={filtroNivel}
            onChange={(e) => setFiltroNivel(e.target.value)}
            className="input-form"
            style={{ width: "130px" }}
          >
            <option value="">Filtrar Nível</option>
            {niveis.map((nivel, index) => (
              <option key={index} value={nivel}>{nivel}</option>
            ))}
          </select>
          <select
            value={filtroModalidade}
            onChange={(e) => setFiltroModalidade(e.target.value)}
            className="input-form"
            style={{ width: "130px" }}
          >
            <option value="">Filtrar Modalidade</option>
            {modalidades.map((modalidade, index) => (
              <option key={index} value={modalidade}>{modalidade}</option>
            ))}
          </select>
          <select
            value={filtroCoordenador}
            onChange={(e) => setFiltroCoordenador(e.target.value)}
            className="input-form"
            style={{ width: "180px" }}
          >
            <option value="">Filtrar Coordenador</option>
            {coordenadores.map((coord, index) => (
              <option key={index} value={coord}>{coord}</option>
            ))}
          </select>
        </div>

        {/* Tabela */}
        <table className="tabela" style={{ marginTop: "10px" }}>
          <thead style={{ backgroundColor: parametros?.cor_cabecalho || "#156082", color: "white", fontSize: "0.75rem" }}>
            <tr>
              <th style={{ textAlign: "left", padding: "8px" }}>Selecionar</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Código</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Nome</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Nível</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Modalidade</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Coordenador</th>
            </tr>
          </thead>
          <tbody>
            {cursosFiltrados.map((curso) => (
              <tr key={curso.id}>
                <td>
                  <input
                    type="radio"
                    name="curso"
                    checked={cursoSelecionado === curso.id}
                    onChange={() => setCursoSelecionado(curso.id)}
                  />
                </td>
                <td>{curso.codigo}</td>
                <td>{curso.nome}</td>
                <td>{curso.nivel}</td>
                <td>{curso.modalidade}</td>
                <td>{curso.coordenador_nome}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {erros.curso && <div className="erro-validacao" style={{ marginTop: "8px" }}>{erros.curso}</div>}

        {/* Botões */}
        <div className="form-actions">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate(`/detalhes-turma/${id}`)}
          >
            Cancelar
          </button>
          <button type="submit" className="btn btn-primary">
            Salvar
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditarTurma;


